import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import LinksSettings from './LinksSettings';
import { useDragHandler } from '../hooks/useDragHandler';
import LinkPill from './LinkPill';

const LinksContent = ({ showSettings, linkList }) => {
  const linksRef = useRef();
  const containerRef = useRef();

  useDragHandler(containerRef, linksRef);

  return (
    <div
      className="sui-flex sui-flex-grow sui-overflow-hidden sui-relative sui-h-8 sui-touch-none"
      ref={containerRef}
      data-component="LinksContent"
    >
      <div
        role="navigation"
        ref={linksRef}
        className="sui-flex sui-px-2 sui-gap-4 sui-items-center sui-absolute sui-select-none"
      >
        {showSettings && (<LinksSettings />)}
        {linkList?.map((link, index) => {
          return (
            <LinkPill
              key={`quick-link-${link.label}-${index}`}
              link={link}
              index={showSettings ? index + 1 : index} // Increase index for position if settings btn is shown
            />
          );
        })}
      </div>
    </div>
  );
};

LinksContent.defaultProps = {
  showSettings: false,
  linkList: undefined,
};

LinksContent.propTypes = {
  showSettings: PropTypes.bool,
  linkList: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    href: PropTypes.string,
    label: PropTypes.string,
  })),
};

export default LinksContent;
